export default {
  appearance: {
    width: 300,
    height: 500,
    showsHeader: true,
    showsFooter: true,
    showsMenu: true,
    showsBrand: true,
    showsNavigation: true,
    showsContentTitle: true,
    showsPageTitle: true,
    textColor: "grey-7",
    bgColor: "white",
    bordered: false,
    borderRadius: 0,
    shadow: 2,
    divider: true,
    brand: {
      title: "DynamicPOV",
      // logo: {
      //   url: "/sandalslogo.png",
      //   style:"",
      // }
    },
    showInfoModal: false, // shows the modal/dialog when consumer is is sequence mode
  },
  menu: {
    position: "left",
    headerTextColor: "white",
    headerBgColor: "grey-9",
    headerTitle: "Menu",
    textColor: "grey-9",
    bgColor: "grey-1",
    darkSeparator: false,
    showPageNumber: true,
  },
  contentTitle: {
    textColor: "grey-10",
    bgColor: "white",
    divider: false,
    height: 60,
    textClass: "",
    formatter: "",
    fontSize: "1.35em",
    justify: "center",
    verticalAlign: "center",
    captionFontSize: ".85em",
    captionTextClass: "text-grey-7",
    captionFormatter: "",
  },
  content: {
    class: "q-py-none",
  },
};
